import { atom } from '@exodus/headless-ui';
const availabilityAtom = atom((get, { selectors }) => {
    return get(selectors.exchange.swapAvailability);
});
export default availabilityAtom;
